import React from "react";
import "./App.css";

import FadeIn from "react-fade-in";

class Samtykke extends React.Component {
  render() {
    return (
      <FadeIn>
        <div className="Info">
          <div className="col-md-10 col-centered">
            <div className="infoCard">
              <h3>
                Deltakere under 16 år må levere samtykkeskjema ved oppmøte
              </h3>
              <br />
              <h5>Skjemaet må være signert av foresatte!</h5>
              <h5>
                Vi har ikke anledning til å slippe inn unge deltakere som ikke
                har med seg dette.
              </h5>
              <h5>
                Vi printer ut skjemaer og har ved inngangen, så hvis ønskelig
                kan foresatte være med deltaker inn og signere der.
              </h5>
              <br />
              <h2>
                <a href="__public/samtykkeskjema.pdf" target="_blank">
                  Samtykkeskjema.pdf
                </a>
              </h2>
            </div>
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default Samtykke;



// WEBPACK FOOTER //
// ./src/Components/App/Samtykke.js